export const PREFERRED_THEME_KEY = "preferredTheme";
